export default __webpack_public_path__ + "static/media/invitationrsvp.9a099342.svg";